import type React from "react"

import { HStack } from "@/nzds/layout"

import { Typography } from "@mui/material"

import { StackedBarGraphSwatch } from "./stacked-bar-graph-swatch"

interface StackedBarGraphTooltipRowProps {
  label: string
  swatchColor?: string
  value: React.ReactNode
}

export const StackedBarGraphTooltipRow: React.FC<
  StackedBarGraphTooltipRowProps
> = ({ label, swatchColor, value }) => (
  <HStack sx={{ alignItems: "center", justifyContent: "space-between" }}>
    <Typography
      sx={{ color: (theme) => theme.palette.text.secondary }}
      variant="caption"
    >
      {label}
    </Typography>
    <HStack sx={{ alignItems: "center", pl: 1 }}>
      {swatchColor ? <StackedBarGraphSwatch color={swatchColor} /> : null}
      <Typography
        sx={{ textAlign: "right", whiteSpace: "normal" }}
        variant="caption"
      >
        {value}
      </Typography>
    </HStack>
  </HStack>
)
